import React, { useContext, useEffect, useState } from "react";
import {
  Loader,
  Message,
  Notification,
  Placeholder,
  SelectPicker,
  Uploader,
  useToaster,
} from "rsuite";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl, authHeaders } from "../../Helpers/ApiHelper";
import profile from "../../Image/profile.svg";
import CustomLoader from "./Loader/CustomLoader";
import DatePicker from "react-date-picker";
import { addYears } from "date-fns";
import secureHash from "../../Helpers/secureHash";
import checkError from "../../Helpers/checkError";
import hasError from "../../Helpers/ErrorHelper";
import validations from "../../Helpers/customValidation";
import Select from "react-select";
import colourStyles from "../../Helpers/colourStyles";

const UserGeneralInfo = () => {
  const toaster = useToaster();
  const { auth, setAuth, setFavoriteCounts } = useContext(Auth);
  const [uploading, setUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [locations, setLocations] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [profileData, setProfileData] = useState();
  const [fileInfo, setFileInfo] = useState(null);
  const [s, ss] = useState("State");

  const fileUploadParams = {
    folder: auth?.userRole.toLowerCase(),
  };
  const genders = ["Male", "Female", "Others"];
  const vatNoData = ["Yes", "No"].map((item) => ({ label: item, value: item }));
  const sources = [
    "Social Media",
    "Press Coverage",
    "A Content Creater",
    "Another Brand",
    "Search Engine",
  ];

  useEffect(() => {
    getProfileData();
  }, []);

  const CalendarIcon = () => {
    return (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        className="rs-picker-toggle-caret rs-icon"
        aria-label="calendar"
      >
        <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
      </svg>
    );
  };

  const getProfileData = () => {
    let config = {
      url:
        auth?.userRole === "BRAND"
          ? ApiUrl.getBrandProfile
          : ApiUrl.getInfluncerProfile,
      method: "GET",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        setProfileData(res?.data);
        setLocations(res?.locations);
        setIsLoading(false);
        ss(res?.data?.found_us_via);
      },
      (err) => {
        setIsLoading(false);
      }
    );
  };

  const findCountry = () => {
    let data = {};

    const locaObj = locations
      ? locations?.find((item) => item.id === profileData?.country_id)
      : "";

    data = {
      label: locaObj?.name,
      value: locaObj?.id,
    };
    if (locaObj !== undefined) {
      return data;
    } else {
      return undefined;
    }
  };

  const isObject = (objVal) => {
    return (
      objVal && typeof objVal === "object" && objVal?.constructor === Object
    );
  };

  const updateProfileData = () => {
    const updatedformData = {
      ...profileData,
      country_id:
        profileData?.country_id !== undefined
          ? isObject(profileData?.country_id)
            ? profileData?.country_id.value
            : profileData?.country_id
          : "",
      found_us_via:
        profileData?.found_us_via !== undefined
          ? isObject(profileData?.found_us_via)
            ? profileData?.found_us_via.value
            : profileData?.found_us_via
          : "",
      have_st_no:
        profileData?.have_st_no !== undefined
          ? isObject(profileData?.have_st_no)
            ? profileData?.have_st_no?.label
            : profileData?.have_st_no
          : "",
      gender:
        profileData?.gender !== undefined
          ? isObject(profileData?.gender)
            ? profileData?.gender?.label
            : profileData?.gender
          : "",
    };

    let config = {
      url:
        auth?.userRole === "BRAND"
          ? ApiUrl.updateBrandProfile
          : ApiUrl.updateInfluncerProfile,
      method: "POST",
      body: {
        ...updatedformData,
        secureHash: secureHash.generate(updatedformData),
      },
    };
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        setIsLoading(false);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("favCounts", res?.total_favorite_counts);
        setFavoriteCounts(res?.total_favorite_counts);
        setAuth({
          ...auth,
          user: res.user,
        });
        toaster.push(
          <Notification type="success" header="Success">
            <Placeholder.Paragraph
              style={{ width: 100, color: "red" }}
              rows={0}
            />{" "}
            Profile updated successfully
          </Notification>,
          {
            placement: "topEnd",
          }
        );
      },
      (err) => {
        if (err?.response?.status === 422) {
          setValidationErrors(err?.response?.data?.errors);
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        }
        setIsLoading(false);
      }
    );
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const handleOnChange = (name, value) => {
    if (name === "dob") {
      value = value !== undefined ? formatDate(value) : "";
    }
    const updatedData = {
      ...profileData,
      [name]: value,
    };
    if (name === "phone") {
      if (!validations.isPositveIntegerNumber(value)) {
        return false;
      }
    } else if (name === "name" || name === "owner_name") {
      if (!validations.isAlphabet(value)) {
        return false;
      }
    }

    // hide validation errors on change
    const IsError = validationErrors?.find((v) => v.field === name);
    if (IsError !== undefined) {
      setValidationErrors(validationErrors?.filter((v) => v.field !== name));
    }

    setProfileData(updatedData);
  };

  const handleUpdateProfile = () => {
    updateProfileData();
  };

  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      <CustomLoader visible={isLoading} />
      {!isLoading && (
        <div className="general-wrapper ">
          <div className="flex justify-center md:justify-start ">
            <h4 className="font-museobb text-black">General Info</h4>
          </div>
          <div className="  w-full rsuit-custom-input">
            <div className="profile-image-upload flex py-2 md:justify-start justify-center ">
              <Uploader
                fileListVisible={false}
                listType="picture"
                headers={authHeaders}
                data={fileUploadParams}
                action={ApiUrl.uploadLogo}
                onUpload={(file) => {
                  setUploading(true);
                  previewFile(file.blobFile, (value) => {
                    setFileInfo(value);
                  });
                }}
                onSuccess={(response, file) => {
                  setUploading(false);
                  setProfileData({
                    ...profileData,
                    avatar_file: response?.file,
                  });
                  toaster.push(
                    <Message type="success" header="Success">
                      Uploaded successfully
                    </Message>
                  );
                }}
                onError={() => {
                  setFileInfo(null);
                  setUploading(false);
                  toaster.push(
                    <Message type="error" header="Error">
                      Upload failed
                    </Message>
                  );
                }}
              >
                <button
                  style={{ width: 150, height: 150, borderRadius: "50%" }}
                >
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    <img
                      alt="fileInfo"
                      src={fileInfo}
                      width="100%"
                      height="100%"
                    />
                  ) : (
                    <img
                      alt="fileInfsso"
                      src={profileData?.avatar ? profileData?.avatar : profile}
                      width="100%"
                      height="100%"
                    />
                  )}
                </button>
              </Uploader>
            </div>
            {auth?.userRole === "BRAND" ? (
              <>
                <div className="flex flex-wrap -mx-3 ">
                  <div className="w-full md:w-1/2 px-3  mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-last-name"
                    >
                      Email
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "email")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="email"
                      value={
                        profileData?.email !== undefined
                          ? profileData?.email
                          : ""
                      }
                      type="email"
                      placeholder="Email"
                      onChange={(e) => {
                        handleOnChange("email", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "email")}
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-brand_name"
                    >
                      Brand Name
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "brand_name")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      value={
                        profileData?.brand_name !== undefined
                          ? profileData?.brand_name
                          : ""
                      }
                      type="text"
                      name="brand_name"
                      placeholder="Brand Name"
                      onChange={(e) => {
                        handleOnChange("brand_name", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "brand_name")}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 ">
                  <div className="w-full md:w-1/2 px-3  mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Phone
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "phone")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="phone"
                      value={
                        profileData?.phone !== undefined
                          ? profileData?.phone
                          : ""
                      }
                      type="text"
                      placeholder="Phone"
                      onChange={(e) => {
                        handleOnChange("phone", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "phone")}
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-website"
                    >
                      Website
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "website")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="website"
                      value={
                        profileData?.website !== undefined
                          ? profileData?.website
                          : ""
                      }
                      type="text"
                      placeholder="Website"
                      onChange={(e) => {
                        handleOnChange("website", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "website")}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 ">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-website"
                    >
                      How did you hear about us?
                    </label>
                    {/* <SelectPicker size="lg" value={profileData?.found_us_via} data={sources?.map(item => ({ label: item, value: item }))}
                  style={{ width: '100%', textDecoration: 'none', borderStyle: 'none', borderRadius: '8px' }}
                  onChange={(value) => { handleOnChange('found_us_via', value) }}
                  placeholder="Location" /> */}

                    <Select
                      className="profileClass "
                      classNamePrefix="profileChild "
                      placeholder="How did you hear about us ?"
                      styles={colourStyles}
                      isClearable={true}
                      onChange={(value) => {
                        handleOnChange("found_us_via", value);
                      }}
                      value={
                        isObject(profileData?.found_us_via)
                          ? profileData?.found_us_via
                          : {
                              label: profileData?.found_us_via,
                              value: profileData?.found_us_via,
                            }
                      }
                      options={sources?.map((item) => ({
                        label: item,
                        value: item,
                      }))}
                    />

                    {hasError(validationErrors, "found_us_via")}
                  </div>

                  <div className="w-full md:w-1/2 px-3  mb-6 md:mb-5 ">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Location
                    </label>
                    {/* <SelectPicker size="lg" value={profileData?.country_id !== undefined ? profileData?.country_id : ''} data={locations ? locations?.map(item => ({ label: item?.name, value: item?.id })) : []}
                  style={{ width: '100%', textDecoration: 'none', borderStyle: 'none', borderRadius: '8px' }}
                  className="sbar"
                  onChange={(value) => { handleOnChange('country_id', value) }}
                  placeholder="Location" /> */}
                    <Select
                      className="profileClass "
                      classNamePrefix="profileChild "
                      placeholder="Country"
                      styles={colourStyles}
                      isClearable={true}
                      value={
                        findCountry(profileData?.country_id) !== undefined
                          ? findCountry(profileData?.country_id)
                          : profileData?.country_id
                      }
                      onChange={(value) => {
                        handleOnChange("country_id", value);
                      }}
                      // options={countries?.map(item => ({ label: item?.name, value: item?.id }))}
                      options={
                        locations
                          ? locations?.map((item) => ({
                              label: item?.name,
                              value: item?.id,
                            }))
                          : []
                      }
                    />
                    {hasError(validationErrors, "country_id")}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3">
                  <div className="w-full md:w-1/2 px-3  mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-website"
                    >
                      Do you have st number
                    </label>
                    {/* <SelectPicker size="lg" value={profileData?.have_st_no !== undefined && profileData?.have_st_no ? profileData?.have_st_no : ''} data={vatNoData ? vatNoData : []}
                  style={{ width: '100%', textDecoration: 'none', borderStyle: 'none', borderRadius: '8px' }}
                  onChange={(value) => { handleOnChange('have_st_no', value) }}
                  placeholder="Do you have ST Number" /> */}

                    <Select
                      className="profileClass"
                      classNamePrefix="profileChild "
                      placeholder="Do you have ST Number"
                      options={vatNoData ? vatNoData : []}
                      styles={colourStyles}
                      onChange={(value) => {
                        handleOnChange("have_st_no", value);
                      }}
                      value={
                        isObject(profileData?.have_st_no)
                          ? profileData?.have_st_no
                          : {
                              label: profileData?.have_st_no,
                              value: profileData?.have_st_no,
                            }
                      }
                    />
                  </div>
                  {profileData?.have_st_no.label === "Yes" && (
                    <div className="w-full md:w-1/2 px-3  mb-6 md:mb-5">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-first-name"
                      >
                        ST Number
                      </label>
                      <input
                        style={{
                          width: "100%",
                          textDecoration: "none",
                          borderRadius: "8px",
                        }}
                        className={`appearance-none block w-full text-gray-700 ${
                          checkError(validationErrors, "website")
                            ? "border-red-600"
                            : "border-[#c7c7c7]"
                        }  rounded py-3 px-4 leading-tight focus:outline-none `}
                        name="vat_no"
                        value={
                          profileData?.vat_no !== undefined
                            ? profileData?.vat_no
                            : ""
                        }
                        type="text"
                        placeholder="ST Number"
                        onChange={(e) => {
                          handleOnChange("vat_no", e.target.value);
                        }}
                      />
                      {hasError(validationErrors, "vat_no")}
                    </div>
                  )}
                </div>
                <div className="flex flex-wrap -mx-3 ">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5 ">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Profile Name
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "owner_name")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="owner_name"
                      value={
                        profileData?.owner_name !== undefined
                          ? profileData?.owner_name
                          : ""
                      }
                      type="text"
                      placeholder="Profile name"
                      onChange={(e) => {
                        handleOnChange("owner_name", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "owner_name")}
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Job title
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "job_title")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="job_title"
                      value={
                        profileData?.job_title !== undefined
                          ? profileData?.job_title
                          : ""
                      }
                      type="text"
                      placeholder="ST Number"
                      onChange={(e) => {
                        handleOnChange("job_title", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "job_title")}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-wrap ">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-last-name"
                    >
                      Email
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "email")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="email"
                      value={
                        profileData?.email !== undefined
                          ? profileData?.email
                          : ""
                      }
                      type="email"
                      placeholder="Email"
                      onChange={(e) => {
                        handleOnChange("email", e.target.value);
                      }}
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Name
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "name")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      value={
                        profileData?.name !== undefined ? profileData?.name : ""
                      }
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      onChange={(e) => {
                        handleOnChange("name", e.target.value);
                      }}
                    />
                    {hasError(validationErrors, "name")}
                  </div>
                </div>
                <div className="flex flex-wrap ">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-last-name"
                    >
                      Phone
                    </label>
                    <input
                      style={{
                        width: "100%",
                        textDecoration: "none",
                        borderRadius: "8px",
                      }}
                      className={`appearance-none block w-full text-gray-700 ${
                        checkError(validationErrors, "phone")
                          ? "border-red-600"
                          : "border-[#c7c7c7]"
                      }  rounded py-3 px-4 leading-tight focus:outline-none `}
                      name="phone"
                      value={
                        profileData?.phone !== undefined
                          ? profileData?.phone
                          : ""
                      }
                      type="text"
                      onChange={(e) => {
                        handleOnChange("phone", e.target.value);
                      }}
                      placeholder="Phone"
                    />
                    {hasError(validationErrors, "phone")}
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Location
                    </label>
                    {/* <SelectPicker size="lg" value={profileData?.country_id !== undefined ? profileData?.country_id : ''} data={locations ? locations?.map(item => ({ label: item?.name, value: item?.id })) : []}
                      style={{ width: '100%', textDecoration: 'none', borderRadius: '10px', border: '1px', }}
                      onChange={(value) => { handleOnChange('country_id', value) }}
                      placeholder="Country" /> */}

                    <Select
                      className="profileClass "
                      classNamePrefix="profileChild "
                      placeholder="Country"
                      styles={colourStyles}
                      isClearable={true}
                      value={
                        findCountry(profileData?.country_id) !== undefined
                          ? findCountry(profileData?.country_id)
                          : profileData?.country_id
                      }
                      onChange={(value) => {
                        handleOnChange("country_id", value);
                      }}
                      // options={countries?.map(item => ({ label: item?.name, value: item?.id }))}
                      options={
                        locations
                          ? locations?.map((item) => ({
                              label: item?.name,
                              value: item?.id,
                            }))
                          : []
                      }
                    />

                    {hasError(validationErrors, "country_id")}
                  </div>
                </div>
                <div className="flex flex-wrap  ">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-last-name"
                    >
                      Gender
                    </label>
                    {/* <SelectPicker size="lg"
                      value={profileData?.gender !== undefined ? profileData?.gender : ''}
                      data={genders?.map(item => ({ label: item, value: item }))}
                      onChange={(value) => { handleOnChange('gender', value) }}
                      style={{ width: '100%', textDecoration: 'none', borderStyle: 'none', borderRadius: '8px' }} searchable={false} placeholder="Select your gender ?" /> */}

                    <Select
                      className="profileClass"
                      classNamePrefix="profileChild "
                      placeholder="Select your gender"
                      options={genders?.map((item) => ({
                        label: item,
                        value: item,
                      }))}
                      styles={colourStyles}
                      onChange={(value) => {
                        handleOnChange("gender", value);
                      }}
                      value={
                        isObject(profileData?.gender)
                          ? profileData?.gender
                          : {
                              label: profileData?.gender,
                              value: profileData?.gender,
                            }
                      }
                    />
                    {hasError(validationErrors, "gender")}
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-5">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                      htmlFor="grid-first-name"
                    >
                      Birthday
                    </label>

                    <DatePicker
                      className={"datepicker-custom-input"}
                      calendarClassName={"date-picker-custom"}
                      clearIcon={null}
                      calendarIcon={<CalendarIcon />}
                      format="dd-MM-y"
                      onChange={(value) => {
                        handleOnChange("dob", value);
                      }}
                      maxDate={addYears(new Date(), -10)}
                      defaultActiveStartDate={addYears(new Date(), -10)}
                      value={profileData?.dob ? new Date(profileData?.dob) : ""}
                      dayPlaceholder="Birth"
                      monthPlaceholder="Of"
                      yearPlaceholder="Date"
                    />
                    {hasError(validationErrors, "dob")}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className=" px-4 py-2 text-right sm:px-6 flex justify-center items-center ">
            <span
              onClick={handleUpdateProfile}
              className="sm:w-[220px] w-[160px] h-[40px] sm:h-[55px] items-center cursor-pointer font-museob inline-flex justify-center rounded-md border border-transparent bg-greenBtn rounded-l-full rounded-r-full text-lg  text-white shadow-sm focus:outline-none
              i  overflow-hidden transform  hover:scale-x-105 hover:scale-y-105 transition duration-300 ease-out"
            >
              UPDATE
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default UserGeneralInfo;
